import { useParams } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import EditMedicalLeaveUpdate from 'modules/timeoff/components/EditMedicalLeaveUpdate'
import { useOnClose } from 'modules/timeoff/hooks/useOnClose'

const EditMedicalLeaveUpdatePage = () => {
  const { leave_update_id: leaveUpdateId } = useParams()
  const onClose = useOnClose()

  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  if (!leaveUpdateId) {
    return null
  }

  return (
    <EditMedicalLeaveUpdate
      leaveUpdateId={parseInt(leaveUpdateId, 10)}
      onClose={onClose}
      contractVersions={contractVersions}
      loading={loading}
    />
  )
}

export default EditMedicalLeaveUpdatePage
